import { CalloutBox } from 'components/Docs/CalloutBox';
import AskMax from 'components/AskMax';
import * as React from 'react';
export default {
  CalloutBox,
  AskMax,
  React
};